import { Component } from "@angular/core";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";
import { AnalyticsService } from "@serasa/shared/services/analytics.service";

@Component({
    selector: "pl-terms",
    templateUrl: "./terms.component.html",
    standalone: false
})
export class TermsPageComponent {
  constructor(private readonly _analyticsService: AnalyticsService) {}

  ngOnInit() {
    this._analyticsService.doPageLoad(SiteSection.ACEITE_TERMOS);
  }
}
